"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var resizeFields = function resizeFields(pageDimensions, field) {
  var originalDimensions = pageDimensions.originalDimensions,
      updatedDimensions = pageDimensions.updatedDimensions;
  var originalHeight = originalDimensions.height,
      originalWidth = originalDimensions.width;
  var updatedHeight = updatedDimensions.height,
      updatedWidth = updatedDimensions.width;
  var newField = {};
  newField.width = updatedWidth / originalWidth * field.width;
  newField.height = updatedHeight / originalHeight * field.height;
  return newField;
};

var _default = resizeFields;
exports.default = _default;